import Vue from 'vue';
import $bizConfig from '@/models/bizConfig.js';
import $web3js from '../web3.js';
import $erc20 from '../erc20/index.js';
import $utils from "@/lib/utils/index.js";

const contractInfo = require('./ifilMiningContractV3.json')

let web3 = $web3js.getWeb3();
let contractAddress = $bizConfig.ifilMiningContractAddressV3;
let contractConst = {
    contract: web3 ? new web3.eth.Contract(contractInfo.abi, contractAddress) : '',
}

const getIfilAddressV3 = () => {
    return contractAddress;
}

const getIfilContractV3 = () => {
    return contractConst.contract;
}

const getIfilContractV3Abi = (funcName) => {
    let arrs = contractInfo.abi.filter((value, key, values) => {
        return funcName === value.name
    })
    return arrs && arrs.length > 0 ? arrs[0] : null;
}


const createNFTV3 = async([_payadd, _inviterid, _prodid, _buyAmount, _payment], options, callback) => {
    _payment = await $erc20.toErc20Value(_payment, _payadd);
    _inviterid = $web3js.stringToBytes32(_inviterid);
    return $web3js.send(getIfilContractV3().methods.createNFT, [_inviterid, _prodid, _buyAmount, _payment], options, callback);
}

const createNFTEstimateSendV3 = async([_payadd, _inviterid, _prodid, _buyAmount, _payment], options) => {
    _payment = await $erc20.toErc20Value(_payment, _payadd);
    _inviterid = $web3js.stringToBytes32(_inviterid);

    let gasPromise = $web3js.estimateSend(getIfilContractV3().methods.createNFT, [_inviterid, _prodid, _buyAmount, _payment], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}

const withdrawBenefitsV3 = ([benefitsToken, _tokens], options, callback) => {
    if (_tokens) {
        return $web3js.send(getIfilContractV3().methods.withdrawBenefits, [benefitsToken, _tokens], options, callback);
    }
    return $web3js.send(getIfilContractV3().methods.withdrawBenefits, [benefitsToken], options, callback);
}

const withdrawBenefitsEstimateSendV3 = async([benefitsToken, _tokens], options) => {
    let gasPromise
    if (_tokens) {
        gasPromise = $web3js.estimateSend(getIfilContractV3().methods.withdrawBenefits, [benefitsToken, _tokens], options);
    } else {
        gasPromise = $web3js.estimateSend(getIfilContractV3().methods.withdrawBenefits, [benefitsToken], options);
    }
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}


const withdrawIFilV3 = ([_amount, _iflAddr], options, callback) => {
    _amount = $web3js.toWei(String(_amount));
    return $web3js.send(getIfilContractV3().methods.withdrawIFil, [_amount, _iflAddr], options, callback);
}

const withdrawIFilEstimateSendV3 = async([_amount, _iflAddr], options) => {
    _amount = $web3js.toWei(String(_amount));

    let gasPromise = $web3js.estimateSend(getIfilContractV3().methods.withdrawIFil, [_amount, _iflAddr], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}

const getInviterV3 = ([_inviterid], options) => {
    _inviterid = $web3js.stringToBytes32(_inviterid);
    return $web3js.call(getIfilContractV3().methods.getInviter, [_inviterid], options);
}
const getNftInfoV3 = ([_tokenid, pledgeContractAddress], options) => {
    return $web3js.call(getIfilContract3().methods.getNFTInfo, [_tokenid], options, handlelNftInfoV3, [pledgeContractAddress]);

}

const getNftInfoV3Call = ([_tokenid]) => {
    return [getIfilAddressV3(), $web3js.encodeFunctionCall(getIfilContractV3Abi('getNFTInfo'), [_tokenid])];

}

const handlelNftInfoV3 = async(res, pledgeContractAddress) => {
    let index = 0;
    let nftinfo = res[index++];
    let calcTotalBenefits = res[index++];
    let calcUnreleaseBenefits = res[index++];
    let v = 0
    let prodid = nftinfo[v++];
    let power = nftinfo[v++];
    let createTime = nftinfo[v++];
    let activeTime = nftinfo[v++];
    let expireTime = nftinfo[v++];

    let gainBenefits = nftinfo[v++];
    let gainedTime = nftinfo[v++];
    let deleted = nftinfo[v++];
    let benefitsToken = nftinfo[v++];
    let reserved0 = nftinfo[v++];
    let reserved1 = nftinfo[v++];

    calcTotalBenefits = await $erc20.fromErc20Value(calcTotalBenefits, pledgeContractAddress);

    calcUnreleaseBenefits = await $erc20.fromErc20Value(calcUnreleaseBenefits, pledgeContractAddress);
    gainBenefits = await $erc20.fromErc20Value(gainBenefits, pledgeContractAddress);


    let usableBenefitQuantity = Vue.prototype.$numberUtils.sub(calcTotalBenefits, gainBenefits)
    return {
        prodid,
        calcTotalBenefits,
        calcUnreleaseBenefits,
        gainBenefits,
        usableBenefitQuantity
    }
}

const userRegisterV3 = ([_inviterid], options, callback) => {
    _inviterid = $web3js.stringToBytes32(_inviterid);
    return $web3js.send(getIfilContractV3().methods.userRegister, [_inviterid], options, callback);
}

const userRegisterEstimateSendV3 = async([_inviterid], options) => {
    _inviterid = $web3js.stringToBytes32(_inviterid);

    let gasPromise = $web3js.estimateSend(getIfilContractV3().methods.userRegister, [_inviterid], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}

const getAndCheckRecvAirdropV3 = ([owner], options) => {
    return $web3js.call(getIfilContractV3().methods.getAndCheckRecvAirdrop, [owner], options);
}

const recvAirdropV3 = (options, callback) => {
    return $web3js.send(getIfilContractV3().methods.recvAirdrop, [], options, callback);
}

const recvAirdropEstimateSendV3 = async(options) => {
    let gasPromise = $web3js.estimateSend(getIfilContractV3().methods.recvAirdrop, [], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}

const mergeNftV3 = ([_prodid, _tokenids], options, callback) => {
    return $web3js.send(getIfilContractV3().methods.mergeNft, [_prodid, _tokenids], options, callback);
}

const mergeNftEstimateSendV3 = async([_prodid, _tokenids], options) => {
    let gasPromise = $web3js.estimateSend(getIfilContractV3().methods.mergeNft, [_prodid, _tokenids], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}

const splitNftV3 = ([_prodid, _tokenids, _powers], options, callback) => {
    return $web3js.send(getIfilContractV3().methods.splitNft, [_prodid, _tokenids, _powers], options, callback);
}

const splitNftEstimateSendV3 = async([_prodid, _tokenids, _powers], options) => {
    let gasPromise = $web3js.estimateSend(getIfilContractV3().methods.splitNft, [_prodid, _tokenids, _powers], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}

const getBuyLimitInfoV3 = ([_prodid, user], options) => {
    return $web3js.call(getIfilContractV3().methods.getBuyLimitInfo, [_prodid, user], options, handleBuyLimitInfoV3);
}

const handleBuyLimitInfoV3 = async(res) => {
    let index = 0;
    let bought = res[index++];
    let canbuy = res[index++];

    return {
        bought,
        canbuy
    }
}

export default {
    getIfilAddressV3,
    getIfilContractV3,
    createNFTV3,
    createNFTEstimateSendV3,
    withdrawBenefitsV3,
    withdrawBenefitsEstimateSendV3,
    withdrawIFilV3,
    withdrawIFilEstimateSendV3,
    userRegisterV3,
    userRegisterEstimateSendV3,
    getInviterV3,
    getNftInfoV3,
    getNftInfoV3Call,
    getAndCheckRecvAirdropV3,
    recvAirdropV3,
    recvAirdropEstimateSendV3,
    mergeNftV3,
    mergeNftEstimateSendV3,
    splitNftV3,
    splitNftEstimateSendV3,
    getBuyLimitInfoV3,
    getIfilContractV3Abi,
    handlelNftInfoV3
}



// WEBPACK FOOTER //
// ./src/lib/contract/ifilMiningV3/index.js